import React, { useMemo, useState } from "react";

import { isEqual } from "lodash-es";

import { MultipleOutcomeFilter } from "src/api/decisionHistoryV2/decisionHistoryQueries";
import { ColumnMultiValueFilter } from "src/base-components/ColumnFilter";

export const EnumFilter: React.FC<{
  dataLoc: string;
  groupKey: string;
  property: string;
  enumValues: string[];
  filter: MultipleOutcomeFilter | null;
  onReset: (groupKey: string, property: string) => void;
  onApply: (groupKey: string, filter: MultipleOutcomeFilter["filter"]) => void;
}> = ({
  dataLoc,
  groupKey,
  property,
  enumValues,
  filter,
  onReset,
  onApply,
}) => {
  const filterValues = useMemo(() => {
    if (!filter) {
      return [];
    }

    return filter.filter.values.map((value) => JSON.stringify(value));
  }, [filter]);

  const [values, setValues] = useState<string[]>(() => filterValues);

  const handleApply = (selected: string[]) => {
    if (selected.length === 0) {
      return onReset(groupKey, property);
    }

    return onApply(groupKey, {
      property,
      operator: "in",
      values: selected.map((value) => JSON.parse(value)),
    });
  };

  const isFiltering = Boolean(filter);
  const options = enumValues?.map((value) => ({
    key: value,
    value: JSON.parse(value),
  }));

  return (
    <ColumnMultiValueFilter
      dataLoc={dataLoc}
      defaultValue={filterValues}
      headline={`Filter by ${property}:`}
      isApplied={isFiltering && isEqual(values, filterValues)}
      isFiltering={isFiltering}
      options={options}
      values={values}
      onApply={handleApply}
      onChange={setValues}
      onResetRequest={() => onReset(groupKey, property)}
    />
  );
};
